import React from 'react'

const Arrow = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 5.00098C23 4.44869 22.5523 4.00098 22 4.00098H6C5.44772 4.00098 5 4.44869 5 5.00098V12.9066C5 13.4589 5.44772 13.9066 6 13.9066L22 13.9066C22.5523 13.9066 23 13.4589 23 12.9066V5.00098ZM21.5 5.34863H6.5V12.184L21.5 12.184V5.34863Z"
        fill="#1072EB"
      />
      <path
        d="M5.16414 20.2221C4.94529 20.008 4.94529 19.6609 5.16414 19.4469L6.53311 18.1078C6.61966 18.0232 6.68313 17.9185 6.73266 17.8081C7.15963 16.8559 8.29748 16.1748 9.63412 16.1747V16.1733H15.7932C16.6444 16.1733 17.3344 16.8482 17.3344 17.6808C17.3344 18.5133 16.6444 19.0677 15.7932 19.0677L12.6408 19.0677L12.6321 19.0987C12.5777 19.2917 12.4981 19.574 12.3965 19.7376L16.6322 20.4459C17.1304 20.5292 17.6413 20.4107 18.052 20.1167L20.6083 18.2864C21.1554 17.7513 22.0425 17.7513 22.5896 18.2864C23.1368 18.8216 23.1368 19.6893 22.5896 20.2245L19.4599 22.621C18.8767 23.0676 18.1436 23.2718 17.4135 23.1911L11.3469 22.5207C11.1056 22.494 10.8656 22.5809 10.6972 22.7558L9.65426 23.8389C9.43541 24.0529 9.08057 24.0529 8.86172 23.8389L5.16414 20.2221Z"
        fill="#1072EB"
      />
      <path
        d="M8.26115 7.3836C8.26115 6.97361 8.59694 6.64123 9.01115 6.64123H18.9888C19.4031 6.64123 19.7388 6.97361 19.7388 7.3836C19.7388 7.7936 19.4031 8.12597 18.9888 8.12597H9.01115C8.59694 8.12597 8.26115 7.7936 8.26115 7.3836Z"
        fill="#1072EB"
      />
      <path
        d="M9.01115 9.16315C8.59694 9.16315 8.26115 9.49551 8.26115 9.90551C8.26115 10.3155 8.59694 10.6479 9.01115 10.6479L14.4598 10.6479C14.874 10.6479 15.2098 10.3155 15.2098 9.90551C15.2098 9.49551 14.874 9.16315 14.4598 9.16315H9.01115Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default Arrow
